module.exports = "//static.hsappstatic.net/LoginUI/static-1.16060/img/okta-logo.svg"